import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BsTelephone } from "react-icons/bs";
import { CiMail } from "react-icons/ci";
import { formService } from '../../../services/formServices'; // Adjust path as needed

const ContactModal = ({ onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        interest: '',
        message: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const nameRegex = /^[a-zA-Z ]{2,30}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let error = false;

        if (!nameRegex.test(formData.name)) {
            alert("Name must be between 2 and 30 characters and only contain letters and spaces");
            error = true;
        } else if (!emailRegex.test(formData.email)) {
            alert("Invalid email address");
            error = true;
        } else if (!formData.interest) {
            alert("Please select your interest");
            error = true;
        } else if (!formData.message.trim()) {
            alert("Please enter your message");
            error = true;
        }

        if (error) {
            setIsSubmitting(false);
            return;
        }

        try {
            // Prepare data for API
            const submissionData = {
                name: formData.name,
                email: formData.email,
                interest: formData.interest,
                message: formData.message,
                sourcePage: window.location.pathname
            };

            // Call API
            await formService.submitContactForm(submissionData);

            // Success
            alert("Thank you for contacting us! We'll get back to you soon.");

            // Reset form
            setFormData({
                name: '',
                email: '',
                interest: '',
                message: '',
            });

            onClose();
        } catch (error) {
            console.error('Contact form submission error:', error);
            alert(error.response?.data?.message || "Failed to submit form. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-modal">
            <div className="modal-grid">
                {/* Left Column */}
                <div className="modal-left">
                    <motion.span
                        className="support-label"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.1 }}
                    >
                        SUPPORT CENTER
                    </motion.span>

                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                    >
                        Schedule your Appointment
                    </motion.h2>

                    <motion.p
                        className="subheading"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                    >
                        Reach out to us if you have common problems and questions.
                    </motion.p>

                    {/* Contact info remains the same */}
                    <div className="contact-cards">
                        <motion.div
                            className="contact-card"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.5 }}
                        >
                            <div className="country-info">
                                <span className="country-name">India</span>
                            </div>

                            <div className="contact-detail">
                                <span className="icon"><BsTelephone fontSize={16} color='black' /></span>
                                <span className="text">+91-7880122103</span>
                            </div>

                            <div className="contact-detail">
                                <span className="icon"><CiMail fontSize={18} color='black' /></span>
                                <span className="text">business@logiqlink.com</span>
                            </div>
                        </motion.div>
                    </div>
                </div>

                {/* Right Column - Form */}
                <motion.div
                    className="modal-right"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3 }}
                >
                    <form onSubmit={handleSubmit} className="contact-form">
                        <div className="form-group">
                            <input
                                type="text"
                                name="name"
                                placeholder="Full Name"
                                value={formData.name}
                                onChange={handleInputChange}
                                required
                                className="form-input"
                                disabled={isSubmitting}
                            />
                        </div>

                        <div className="form-group">
                            <input
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleInputChange}
                                required
                                className="form-input"
                                disabled={isSubmitting}
                            />
                        </div>

                        <div className="form-group">
                            <select
                                name="interest"
                                value={formData.interest}
                                onChange={handleInputChange}
                                required
                                className="form-select"
                                disabled={isSubmitting}
                            >
                                <option value="">Select Interest</option>
                                <option value="consultation">Consultation</option>
                                <option value="support">Technical Support</option>
                                <option value="partnership">Partnership</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <textarea
                                name="message"
                                placeholder="Your Message"
                                rows="4"
                                value={formData.message}
                                onChange={handleInputChange}
                                required
                                className="form-textarea"
                                disabled={isSubmitting}
                            />
                        </div>

                        <motion.button
                            type="submit"
                            className="send-btn"
                            disabled={isSubmitting}
                            whileHover={!isSubmitting ? { scale: 1.02 } : {}}
                            whileTap={!isSubmitting ? { scale: 0.98 } : {}}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </motion.button>
                    </form>
                </motion.div>
            </div>
        </div>
    );
};

export default ContactModal;